import {Button} from '@chekinapp/ui';
import styled, {css} from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

type WrapperProps = {
  $isKeyboardVisible?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  width: 100%;
  gap: 16px;
  transition: padding 0.3s ease-in-out;

  ${props =>
    props.$isKeyboardVisible &&
    css`
      padding-bottom: 400px;
    `}

  @media (min-width: ${DEVICE.laptop}) {
    margin-top: 48px;
  }
`;

export const CustomBackButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 24px;

  & .button__left-icon {
    padding-right: 10px;
  }
`;

type FieldsProps = {
  $rowsCount: number;
};

export const Fields = styled.div<FieldsProps>`
  display: grid;
  grid-column-gap: 50px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(${props => props.$rowsCount}, auto);
  text-align: center;
  max-width: 778px;
  position: relative;

  @media (max-width: ${DEVICE.laptop}) {
    grid-template-columns: 1fr;
  }

  @media (max-width: ${DEVICE.laptop}) {
    grid-column-gap: 10px;
  }

  @media (max-width: ${DEVICE.laptop}) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    display: flex;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  @media only screen and (max-width: ${DEVICE.laptopL}) {
    flex-direction: column;
    align-items: center;
    row-gap: 12px;
  }

  @media only screen and (max-width: ${DEVICE.laptop}) {
    flex-direction: column;
    align-items: center;
    row-gap: 15px;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 48px;

  @media (min-width: ${DEVICE.laptop}) {
    justify-content: start;
  }
`;
